import AdminDashboard from "../ADMIN/pages/AdminDashboard/AdminDashboard";
import AdminDashboardIcon from "./icons/DashboardIcon";
import AdminDashboardActiveIcon from "./icons/DashboardActiveIcon";

import BusinessesList from "../ADMIN/pages/BusinessesList/BusinessesList";
// import BusinessesListIcon from "./icons/DashboardIcon";
// import BusinessesListActiveIcon from "./icons/DashboardActiveIcon";

export const AdminRoutes = [
  // Admin Routes
  {
    id: "admin_dashboard",
    path: "/user/admin/dashboard",
    title: "Admin Dashboard",
    layout: "user",
    parent: true,
    component: <BusinessesList />,
    icon: <AdminDashboardIcon />,
    activeIcon: <AdminDashboardActiveIcon />,
  },
];
